export default __webpack_public_path__ + "static/media/2.5.fe062796.mp3";